module.exports = __webpack_public_path__ + "static/img/creative2.1fa0bcaf.png";